<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path d="M14.38 7.81h-1.9v1.91h1.9v-1.9ZM11.52 7.81h-1.9v1.91h1.9v-1.9ZM8.66 7.81h-1.9v1.91h1.9v-1.9Z" />
    <path
      d="m22 18.59-2.5-12.5A2.87 2.87 0 0 0 16.75 4h-1.41v1.9h1.4c.44 0 .8.3.91.64l.23 1.17-.1.1h-2.43v1.91h.44l-7.12 6.82v-5.87h-1.9v.85L2 17.16v2.57h4.96c.73 0 1.44-.28 1.97-.8l9.4-9 1.8 9.04L22 18.6v-.01ZM6.75 14.44v3.37h-2.9l2.9-3.37Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
